import { StyledPoint, StyledTooltipWrapper } from "./styles";

interface ChartTooltipProps {
    name: string;
    value: string;
    color: string;
}

export const ChartTooltip = ({ name, value, color }: ChartTooltipProps) => (
    <StyledTooltipWrapper>
        <StyledPoint color={color} /> <span>{name}</span> <span>{value}</span>
    </StyledTooltipWrapper>
);
